import React from 'react';

import { AssetGalleryPage } from './asset-gallery/AssetGalleryPage';
import { useMobileShell } from '../shell/useMobileShell';
import { MobileShell } from '../shell/MobileShell';

/**
 * Asset gallery route. Thin wrapper over the page component so the F9
 * route table doesn't churn when F15-2/-3 add modal + cross-link behavior.
 *
 * Spike 1 — when the viewport is mobile-shell-sized, host the gallery inside
 * MobileShell with the gallery tab pre-selected. The gallery itself is
 * already grid-responsive (card flow stacks at narrow widths), so wrapping
 * it gives the user the bottom-tab navigation back to a lab without changing
 * the gallery component.
 */
export const AssetGalleryRoute: React.FC = () => {
  const { isMobileShell } = useMobileShell();
  if (!isMobileShell) return <AssetGalleryPage />;
  return (
    <MobileShell
      title="Gallery"
      initialTab="gallery"
      canvasSlot={null}
      gallerySlot={<AssetGalleryPage />}
    />
  );
};
